import { Checkbox, CheckboxProps } from '@mantine/core'
import React from 'react'

export function ECheckBox(props: CheckboxProps) {
  return (
    <Checkbox
      {...props}
      styles={{
        label: {
          fontSize: '15px',
          fontWeight: 400,
          color: '#374151',
          cursor: 'pointer',
        },
        input: {
          cursor: 'pointer',
        },
        ...props.styles as any,
      }}
    />
  )
}
